import axios from 'axios';
import { CONSOLE_URL } from '../consts/config';

export interface GameRecord { name?: string; teamName?: string; points: number; country?: string; levelReached?: number }
export interface GameRecords { alltime: GameRecord[]; monthly: GameRecord[] }
export const recordOptions = [
  ...[1, 2, 3, 4].map(players => ({ key: 'bubblewar' + players, game: 'bubblewar', players })),
  ...[1, 2, 3, 4].map(players => ({ key: 'rivercirclecoop6_' + players, game: 'rivercirclecoop', players })),
  { key: 'roperage', game: 'roperage', players: 0 },
];
export async function getRecords(gameKey: string, signal?: AbortSignal): Promise<GameRecords> {
  const response = await axios.get('/getRecords', { baseURL: CONSOLE_URL, params: { gameKey }, signal });
  const list = (value: unknown): GameRecord[] => Array.isArray(value)
    ? value.filter(record => record && typeof record.points === 'number' && Number.isFinite(record.points)) : [];
  if (!response.data || typeof response.data !== 'object' || Array.isArray(response.data)) throw Error('Invalid records response');
  return { alltime: list(response.data.alltime), monthly: list(response.data.monthly) };
}
